<template>
  <div style="background: #000;height: 100vh" v-if="loading">

    <div style="width: 100%; height: 100% ; position: relative">
      <div class="score-head">
        <div class="score-logo" style="position: absolute; top: 15px;left: 50px">
          <div class="score-logo-box" style="padding:2px; border-radius: 100%;">
            <img src="../../../assets/images/score/logo2.png" alt=""
                 style="width: 45px;height: 45px;border-radius: 100%; border:2px solid #fff">
          </div>
        </div>

        <!--        <div class="score-menu" style="position: absolute; top: 20px;right: 50px">-->
        <!--          <div class="score-menu-box">-->
        <!--            <a-icon type="menu" @click="drawerVisible = true" :style="{ fontSize: '26px'}"/>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="score-head-body">
          <div class="score-head-line score-head-line--title">
            {{ row.saiqu_name }}{{ row.title }}
          </div>
          <div class="score-head-line score-head-line--subject">
            {{ subjectRow.subject_name }}
          </div>
          <div class="score-head-team-row">
            <span class="score-head-mingcheng">{{ subjectRow.mingcheng }}</span>
            <span v-if="subjectRow && subjectRow.id" class="score-head-jianlu-inline">
              <span :class="jianluHeadStatusClass">{{ jianluHeadStatusText }}</span>
              <span
                v-if="Number(subjectRow.jianlu_status) === 6 && subjectRow.jianlu_note"
                class="score-head-jianlu-note-inline"
              >{{ subjectRow.jianlu_note }}</span>
            </span>
          </div>
        </div>

      </div>

      <div class="score-content flex-start">
        <div class="score-content-left">
          <div class="score-content-operate">
            <div class="score-li" @click="onScoreOperate(index + 1)" v-for="(item, index) in caipan" :key="index">
              <div class="score-li-box">
                <div class="caipan-info" :class="item.status != 1 ? 'caipan-info-disabled' : ''">
                  <div class="caipan-name">
                    裁判{{ index + 1 }}({{ item.name }}) 
                  </div>

                  <div class="caipan-score">{{ subjectRow['score' + (index + 1)] }}
                  <van-icon name="play" color="#f00" v-if="subjectRow['score_fix_' + (index + 1)]  =='add'"  style=" ;transform: rotate(-90deg);" />
                  <van-icon name="play"   color="#0dac0d" v-else-if="subjectRow['score_fix_' + (index + 1)]  =='pen'"  style="transform: rotate(90deg);" />

                  </div>
                  <div class="caipan-comment">{{
                      subjectRow['comment' + (index + 1)] ?
                          '已评价' : '暂无评语'
                    }}
                  </div>
                </div>
                <div
                    :class="item.status === 1 ? 'caipan-button-active flex-between' : 'caipan-button-disabled flex-center'">
                  <div class="caipan-button-li">
                    {{ item.status === 1 ? '在线' : '离线' }}
                  </div>
                </div>
              </div>


            </div>

            <div class="score-li">
              <div class="score-li-box">
                <div class="caipan-info"  >
                  <div class="caipan-name">加分</div>

                  <div class="caipan-score">{{ subjectRow['score_add'] }}</div>
                  <div class="caipan-comment">{{
                      subjectRow['comment_add'] ? subjectRow['comment_add']
                          :
                          '暂无评语'
                    }}
                  </div>
                </div>

                <!--                <div class="caipan-button caipan-button-score flex-center">-->
                <!--                  <div class="caipan-score-li" @click="onScoreOperate('_add')">-->
                <!--                    <img src="../../assets/icon-score-edit.png" alt="">-->
                <!--                    <div>编辑</div>-->
                <!--                  </div>-->
                <!--                </div>-->

              </div>

            </div>

            <div class="score-li">
              <div class="score-li-box">
                <div class="caipan-info" >
                  <div class="caipan-name">减分</div>

                  <div class="caipan-score">{{ subjectRow['score_pen'] }}</div>
                  <div class="caipan-comment">{{
                      subjectRow['comment_pen'] ? subjectRow['comment_pen']
                          :
                          '暂无评语'
                    }}
                  </div>
                </div>

                <!--                <div class="caipan-button caipan-button-score flex-center">-->
                <!--                  <div class="caipan-score-li" @click="onScoreOperate('_pen')">-->
                <!--                    <img src="../../assets/icon-score-edit.png" alt="">-->
                <!--                    <div>编辑</div>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
            </div>


            <div class="score-li">
              <div class="score-li-box">
                <div class="caipan-info" >
                  <div class="caipan-name">小分均分</div>

                  <div class="caipan-score">{{ subjectRow['score_ava']||0.0 }}</div>
                  <div class="caipan-comment">{{
                      subjectRow['comment_pen'] ? subjectRow['comment_pen']
                          :
                          '暂无评语'
                    }}
                  </div>
                </div>
 
              </div>
            </div>

            <div class="score-li">
              <div class="score-li-box">
                <div class="caipan-info"  >
                  <div class="caipan-name">高级裁判组得分</div>

                  <div class="caipan-score">{{ subjectRow['score_s'] }}</div>
                  <div class="caipan-comment">{{
                      subjectRow['comment_pen'] ? subjectRow['comment_pen']
                          :
                          '暂无评语'
                    }}
                  </div>
                </div>
 
              </div>
            </div>


          </div>
        </div>
        <div class="score-content-right">
          <div class="content-right-head flex-between">
            <div class="right-head-li" :class="subjectRow.jgroup === 1 ? 'right-head-li-disabled' : ''">
              A组裁判{{ caipanListA.length > 0 ? parseInt(currentIndex) + 1 + '/' + scoreList.length : '0/0' }}
            </div>
            <div class="right-head-line"></div>
            <div class="right-head-li" :class="subjectRow.jgroup === 0 ? 'right-head-li-disabled' : ''">
              B组裁判{{ caipanListB.length > 0 ? parseInt(currentIndex) + 1 + '/' + scoreList.length : '0/0' }}
            </div>
          </div>

          <div class="content-right-body">
            <div class="right-body-top flex-between">
              <div>总得分</div>
              <!--              <a-button type="primary" @click="handleRank">查看排名{{-->
              <!--                  subjectRow.rank != '-' ? '（' +-->
              <!--                      subjectRow.rank + '）' : ''-->
              <!--                }}-->
              <!--              </a-button>-->
              <!--              <a-button type="primary" @click="handleRank">查看排名-->
              <!--              </a-button>-->
            </div>

            <div class="right-body-score">
              {{ subjectRow.score_total }}
            </div>

          </div>

          <div class="content-right-foot content-right-foot-start" v-if="subjectRow.current">
            <div class="content-right-foot" v-if="subjectRow.status == 1">提交分数</div>
            <!--            <a-popconfirm title="确认提交分数吗?" @confirm="onSubjectStatusChange(2)" okText="确定"-->
            <!--                          cancelText="取消" v-if="subjectRow.status == 1">-->
            <!--              <div class="content-right-foot content-right-foot-score">提交分数</div>-->
            <!--            </a-popconfirm>-->
            <div class="content-right-foot content-right-foot-started" v-else-if="subjectRow.status == 2">
              已完成
            </div>
            <div class="content-right-foot" v-else-if="subjectRow.status == 3">
              已弃权
            </div>
          </div>

          <div class="content-right-foot" v-else>
            <div class="content-right-foot-start" v-if="subjectRow.status == 3">已弃权</div>
            <div class="content-right-foot content-right-foot-started" v-else-if="subjectRow.status == 2">
              已完成
            </div>
            <div class="content-right-foot content-right-foot-start" v-else>开始评分</div>
          </div>
        </div>

      </div>
      <div class="score-foot">
        <div class="foot-index">{{ parseInt(currentIndex) + 1 }} / {{ scoreList.length }}</div>
        <div class="foot-content flex-between">
          <img src="https://static.dierqudao.com/images/cca/icon-score-left-disabled.png" v-if="currentIndex === 0"
               alt="">
          <img src="https://static.dierqudao.com/images/cca/icon-score-left.png" v-else @click="onSubjectPrev">

          <div class="foot-li-box flex-start">
            <div :style="'width: ' + 100 / scoreList.length + '%'"
                 v-for="(item, index) in scoreList" :key="item.id">
              <div v-if="item.status == 2" class="foot-li foot-li-active"
                   :class="index == currentIndex ? 'foot-li-selected' : ''">{{ index + 1 }}
              </div>
              <div v-if="item.status == 3" class="foot-li foot-li-fail"
                   :class="index == currentIndex ? 'foot-li-selected' : ''">{{ index + 1 }}
              </div>
              <div :class="index == currentIndex ? 'foot-li-selected' : ''" v-if="item.status == 1" class="foot-li">
                {{ index + 1 }}
              </div>
            </div>
          </div>
          <img src="https://static.dierqudao.com/images/cca/icon-score-right-disabled.png"
               v-if="currentIndex === scoreList.length - 1"
               alt="">
          <img src="https://static.dierqudao.com/images/cca/icon-score-right.png" v-else @click="onSubjectNext" alt="">
        </div>
      </div>


      <!--      <div style="color: #fff">subjectRow.status || {{subjectRow}}</div>-->
    </div>



    <van-action-sheet v-model="actionshow" title="正在进行">
      <van-cell-group>
        <van-cell title="上调分数"   @click="onReSetScore('add')" />
        <van-cell title="下调分数"   @click="onReSetScore('pen')" />
      </van-cell-group>
    </van-action-sheet>

  </div>
</template>
<style scoped>
body {
  overflow-y: hidden;
}

.army-li {
  padding: 10px 0;
  border-bottom: 1px solid #efefef;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.score-foot {
  margin: 20px 30px 0;
}

.score-foot img {
  width: 20px;
  cursor: pointer;
}

.foot-index {
  color: #aaa;
  margin-bottom: 6px;
  text-align: center;
}

.foot-li-box {
  width: 92%;
}

.foot-li {
  height: 34px;
  border: 1px solid #4A4A4A;
  text-align: center;
  line-height: 34px;
  color: #666;
  font-size: 16px;
}

.foot-li-active {
  background: #1F85E2;
}

.foot-li-fail {
  background: #FF4D50;
}

.foot-li-selected {
  border: 1px solid #fff;
}

.score-content-right {
  width: 25%;
  background: #333333;
  border-radius: 10px;
  color: #fff;
  overflow: hidden;
  position: relative;
}

.content-right-head {
  padding: 20px 15px 10px;
  border-bottom: 1px dashed #aaa;
  font-size: 16px;
}

.right-head-li {
  width: 50%;
  text-align: center;
}

.right-head-li-disabled {
  color: #666;
}

.content-right-body {
  padding-top: 15px;
}

.right-body-top {
  padding: 0 20px;
}

.right-body-score {
  font-size: 80px;
  text-align: center;
  padding: 55px 0;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
}

.right-body-time {
  padding-left: 20px;
}

.right-body-time-one {
  display: flex;
  align-items: center;
}

.right-head-line {
  width: 1px;
  height: 15px;
  background: #aaa;
}

.right-body-time-rule button {
  margin-left: 10px;
}

.body-time-value {
  font-size: 30px;
  font-family: Helvetica;
  color: #FFFFFF;
}

.time-rule-value {
  font-size: 18px;
  font-family: Helvetica;
  color: #D0021B;
}

.body-time-button {
  margin-top: 5px;
}

.body-time-button button {
  margin-right: 10px;
}

.content-right-foot {
  /*position: absolute;*/
  bottom: 0;
  height: 60px;
  line-height: 60px;
  width: 100%;
  text-align: center;
  font-size: 22px;
}

.content-right-foot-un-start {
  background: #1F85E2;
  cursor: pointer;
}

.content-right-foot-started {
  background: #0EB791;
}

.content-right-foot-start {
  background: #4A4A4A;
}

.content-right-foot-score {
  background: #FF4D50;
}

.score-head {
  background-color: #1378bd;
  background-image: url("https://static.dierqudao.com/images/cca/score-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 120px;
  min-height: 120px;
  height: auto;
  padding-bottom: 12px;
  text-align: center;
  color: #fff;
  font-weight: 500;
}

/* 与左侧 Logo 对称留白，整块标题区水平居中 */
.score-head-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 0 100px;
  text-align: center;
}

.score-head-line {
  width: 100%;
  text-align: center;
  box-sizing: border-box;
}

.score-head-line--title {
  font-size: 22px;
  padding: 10px 0;
  line-height: 1.35;
}

.score-head-line--subject {
  font-size: 18px;
  line-height: 1.4;
  padding-bottom: 2px;
}

.score-head-team-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 8px 12px;
  font-size: 16px;
  line-height: 1.45;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  text-align: center;
}

.score-head-mingcheng {
  font-weight: 500;
  word-break: break-all;
  text-align: center;
}

.score-head-jianlu-inline {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px 8px;
  font-size: 15px;
  white-space: normal;
  text-align: center;
}

.score-head-jianlu-label {
  opacity: 0.92;
  font-weight: 500;
  color: #fff;
}

.score-head-jianlu-st {
  font-weight: 700;
  letter-spacing: 0.02em;
}

.score-head-jianlu-st--0 {
  color: #f8fafc;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.85), 0 1px 2px rgba(0, 0, 0, 0.4);
}

.score-head-jianlu-st--4 {
  color: #bef264;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.85), 0 1px 3px rgba(0, 0, 0, 0.45);
}

.score-head-jianlu-st--5 {
  color: #86efac;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
}

.score-head-jianlu-st--6 {
  color: #ff8585;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.8), 0 1px 2px rgba(0, 0, 0, 0.35);
}

.score-head-jianlu-st--7 {
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
}

.score-head-jianlu-st--8 {
  color: #fcd34d;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.score-head-jianlu-st--9 {
  color: #ff6b6b;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.85), 0 1px 2px rgba(0, 0, 0, 0.4);
}

.score-head-jianlu-st--x {
  color: #e2e8f0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.score-head-jianlu-note-inline {
  font-size: 15px;
  font-weight: 600;
  color: #fff7ed;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.55);
  word-break: break-all;
  max-width: 100%;
}

.score-head-jianlu-note-inline::before {
  content: "·";
  margin: 0 6px 0 2px;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
}

.score-content {
  margin: 15px 20px 0;
}

.score-content-left {
  width: 75%;
}

.score-content-operate {
  display: flex;
  flex-wrap: wrap;
}

.score-li {
  width: 20%;
  text-align: center;
}

.score-li-box {
  margin: 0 10px 10px 0;
  background: #fff;
  overflow: hidden;
  border-radius: 10px;
}

.caipan-info {
  padding: 6px 0;
  cursor: pointer;
}

.caipan-info-disabled {
  background: #EEEEEE;
}

.caipan-name {
  font-weight: 500;
  color: #4A4A4A;
}

.caipan-score {
  font-size: 28px;
  font-weight: 500;
  color: #000;
  font-family: DINAlternate-Bold, DINAlternate;
}

.caipan-comment {
  color: #9B9B9B;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caipan-button {
  padding: 0 5px;
  height: 35px;
  width: 100%;
}

.caipan-button-active {
  background: #1F85E2;
}

.caipan-button-score {
  background: #0EB791;
  cursor: pointer;
}

.caipan-button-disabled {
  background: #9B9B9B;
}

.caipan-button-li {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  height: 35px;
  cursor: pointer;
  color: #fff;
  width: 100%;
}

.caipan-score-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  color: #fff;
  height: 35px;
  cursor: pointer;
}

.caipan-button-li img, .caipan-score-li img {
  width: 14px;
  margin-right: 5px;
}

</style>
<script>
import Vue from 'vue';
import moment from 'moment'
import {Toast,Icon} from "vant";

Vue.use(Icon)

export default {
  name: 'CommonScoreCheck',
  components: { 
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      drawerVisible: false,
      actionshow:false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      // tableHeight:document.documentElement.clientHeight-180,
      // tableHeight:300,
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperColNew: {
        xs: {span: 24},
        sm: {span: 12},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      row: {
        current_index: -1,
        current_indexb:-1,
        caipan_type_num: 1,
        sai_time_total: '00:00:00', //比赛用时
        is_admin: true
      },
      list: [{}], 
      commentList: [],
      defaultCaipanList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], //默认裁判数量
      caipan: [],
      caipanListA: [],
      caipanListB: [],

      caipanAdmin: {}, // 裁判长信息
      scoreList: [{stime: ''}],
      formData: {
        id: 0
      },

      subjectOptions: [],
      subjectQuery: [],

      currentIndex: -1, //当前队伍
      currentSubjectIndex: -1, //当前比赛队伍
      scoreRankList: [], //项目排名

      // 单只项目队伍信息
      subjectRow: {
        id: 0,
        rank: 0,
        score_total: '0.0', // 总得分
        jgroup: '',
        subject_name: 'xx',
        mingcheng: 'xx',
        timeStatus: '',
        jianlu_status: undefined,
        jianlu_note: '',
      },

      isContinue: false,
      timeVisible: false,
      sTime: '00:00:00', //比赛用时字符串
      socket: '',

      status: '', // pause
      timerList: [],
      timeTotal: 0,
      timeString: 0,
      scoreValue: '', //分值
      scoreComment: '', // 减分评语
      scoreCommentId: '', // 减分评语id
      caipanIndex: 0, //操作的裁判

      dataId: 0,
      dataRow: {},

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
      timer: null
    }

  },
  mounted() {
    const that = this
    that.formData.id = that.$route.query.id || 86
    document.title="评分显示"
    // 开始socket
    // that.init()

    // 获取数据
    that.fetch();
    that.timer = setInterval(function () {
      that.fetch();
    }, 4000)
  },
  destroyed() {
    // 销毁监听
    this.socket.close()
  },
  computed: {
    jianluHeadStatusText() {
      const map = {
        0: '待检录',
        1: '检录1',
        2: '检录2',
        // 4: '已签到',
        5: '检录完成',
        6: '待整改',
        7: '比赛完成',
        8: '弃权',
        // 9: '超时未到',
      }
      const s = this.subjectRow ? Number(this.subjectRow.jianlu_status) : NaN
      if (Number.isNaN(s)) {
        return '—'
      }
      return Object.prototype.hasOwnProperty.call(map, s) ? map[s] : '—'
    },
    jianluHeadStatusClass() {
      const s = this.subjectRow ? this.subjectRow.jianlu_status : null
      if (s === null || s === undefined || s === '') {
        return ['score-head-jianlu-st', 'score-head-jianlu-st--x']
      }
      const n = Number(s)
      if (Number.isNaN(n)) {
        return ['score-head-jianlu-st', 'score-head-jianlu-st--x']
      }
      const known = [0, 4, 5, 6, 7, 8, 9]
      const key = known.indexOf(n) !== -1 ? n : 'x'
      return ['score-head-jianlu-st', 'score-head-jianlu-st--' + key]
    },
  },
  methods: {
    moment,


    // 操作分数
    onScoreOperate(index) {
      const that = this
      console.log('onScoreOperate')
      that.caipanIndex = index  
      that.actionshow = true
    },

  // 重新设置分数
  onReSetScore(type='') { 
      const that = this
      that.actionshow = false
      that.$api.post('/api/dscore/setScoreFix', {
          id: that.subjectRow.id,
          score_index: this.caipanIndex,
          type: type, 
      }, (res => {
         Toast('操作成功')
        that.fetch();
        }), (res) => { 
        Toast(res.msg)
      }
      )
  },


    fetch() {
      //刷新数据
      const that = this
      that.$api.post('/api/dscore/scoreList', {id: that.formData.id}, (res => {
            // 获取开始 比赛的队伍 
            if(that.row.current_indexb  !=res.data.row.current_indexb){
                that.currentIndex = that.currentSubjectIndex = that.row.current_indexb = res.data.row.current_indexb
            }
            if(that.row.current_index  !=res.data.row.current_index){
                that.currentIndex = that.currentSubjectIndex = that.row.current_index = res.data.row.current_index
            }
            
            /*
            res.data.list.map(row => {
              // if (that.currentIndex == -1) {
                if (row.current) {
                  that.currentIndex = that.currentSubjectIndex = row.index
                }
              // }
            })*/

            that.loading = true
            // 格式化数据
            that.formatData(res.data)
          })
      )
    },

    // 格式化数据
    formatData(data) {
      const that = this
      that.scoreList = data.list
      that.row = data.row

      that.queryParam.sjsq = [1, data.row.saiqu]

      let caipanMain = {},
          caipanCheck = {}

      // 定义 比赛总时间规则
      that.row.sai_time_total = data.row.sai_time_total ? data.row.sai_time_total : '00:00:00'
      that.caipan = data.caipan

      data.caipan.map(row => {
        if (row.type == '裁判') {
          if (row.jgroup == 0) {
            that.caipanListA.push(row)
          } else {
            that.caipanListB.push(row)
          }
        }

        // 取复核的信息
        if (row.type == '复核主任') {
          caipanMain = row
        }

        if (row.type == '复核委员') {
          caipanCheck = row
        }
      })
      // console.log(caipanMain, caipanCheck)

      that.caipanAdmin = Object.keys(caipanMain).length ? caipanMain : caipanCheck

      // if(!Object.keys( that.caipanAdmin).length) {
      //   Toast.fail('请先设置复核')
      //   return
      // }

      // 获取参赛队伍 信息
      that.getSubjectRow()
      // console.log(that.caipanListA, that.caipanListB)
    },

    // 获取单只队伍详情
    getSubjectRow() {
      let that = this,
          index = that.currentIndex,
          list = that.scoreRankList,
          caipanList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          rank = 0, //名次
          subjectRow = that.subjectRow = that.scoreList[index],
          caipan = !subjectRow.jgroup || subjectRow.jgroup == 0 ? that.caipanListA : that.caipanListB

      that.sTime = subjectRow.stime

      list.map((row) => {
        if (row.id == that.subjectRow.id) {
          rank = row.rank_value
        }
      })
      that.subjectRow.rank = rank

      // console.log('scoreList22', caipan,that.caipanListA, that.caipanListB)

      // 根据index 设置裁判位置
      // vue的双向绑定导致 defaultCaipanList值发生变化 循环时重置为预设的10个裁判位
      caipanList.map((item, scoreIndex) => {
        caipan.map((row) => {
          if (scoreIndex == row.index) {
            caipanList[scoreIndex] = row ? row : ''
          }
        })
      })

      // 运行的timer丢失
      that.getListTimer()

      that.caipan = caipanList
      console.log("getSubjectRow", that.subjectRow, caipanList, that.scoreList)

      // 获取排名信息
      // that.getRankList(that.subjectRow.subject)

      that.drawerVisible = false
    },

    // 切换下一支队伍
    onSubjectNext() {
      let that = this,
          index = that.currentIndex
      that.currentIndex = parseInt(index) + 1

      that.getSubjectRow()
    },

    // 切换指定队伍
    onSubjectCurrent(index) {
      let that = this
      that.currentIndex = index

      that.getSubjectRow()
    },

    // 切换上一支队伍
    onSubjectPrev() {
      let that = this,
          index = that.currentIndex
      that.currentIndex = index - 1

      that.getSubjectRow()
    },

    init: function () {
      if (typeof (WebSocket) === "undefined") {
        alert("您的浏览器不支持socket")
      } else {
        // 实例化socket
        let that = this
        this.socket = new WebSocket(wsRoot)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage

        this.socket.onclose = function (e) {
          // that.reconnect()
          console.log('websocket 断开：' + e.code + ' ' + e.reason + ' ' + e.wasClean)
        }
      }
    },
    open: function () {
      // console.log('heartStart',this.row)
      this.heartStart()
      this.heartCheck()
    },
    error: function () {
      console.log("连接错误")
      // this.reconnect()
    },
    getMessage: function (msg) {
      // console.log('getMessage', msg.data)
      let data = JSON.parse(msg.data),
          that = this


      // 判断在数组中
      let typeList = ['caipan_login', 'caipan_logout', 'score_submit', 'time_update', 'sai_giveup']

      console.log('typeList.includes(data.type)', typeList.includes(data.type), data)
      if (typeList.includes(data.type) && that.formData.id == data.data.id) {
        that.fetch()
      }

      return;

      switch (data.type) {

          /**
           * caipan_login  名称：裁判登录， 刷新对象：裁判长
           * caipan_logout 名称：裁判退出， 刷新对象：裁判长刷新
           * score_submit  名称：裁判提交分数 刷新对象：裁判长刷新
           * time_update ，名称：时间更新 刷新对象：裁判长刷新
           *
           * score_reset ，名称：普通裁判重新打分 刷新对象：指定的普通裁判刷新
           * sai_start  名称：开始评分， 刷新对象：普通裁判
           * sai_complete 名称：评分完成， 刷新对象：复核
           * sai_giveup 名称：弃权， 刷新对象：复核
           */


        case 'caipan_common' :
          // 普通裁判登录 打分等
          //  if(id=='') 当前场次
          this.fetch()
          break
        case 'caipan_common_logout' :
          // 普通裁判下线 执行状态更改
          this.onLoginOutAuto(data) //delete
          break
        default:
          console.log('default')
      }
    },
    send: function (params) {
      this.socket.send(params)
    },
    close: function () {
      console.log("socket已经关闭")
    },

    heartStart() {
      let that = this

      let token = that.caipanAdmin.num,
          data = {}

      let val = that.formatSocketInfo('heart_start', token, data)
      that.socket.send(val)
    },

    heartCheck() {
      let that = this;
      that.heartTimer = setInterval(function () {

        let token = that.caipanAdmin.num,
            data = {
              'id': that.formData.id
            }

        let val = that.formatSocketInfo('heart_check', token, data)
        that.socket.send(val)
      }, 8000)
    },

    formatSocketInfo(type, token, data) {
      return JSON.stringify({
        'type': type,
        'token': token,
        'data': data,
      })
    },

    reconnect() {
      let that = this,
          lockReconnect = that.lockReconnect,
          tt = that.timer

      // 重连
      if (lockReconnect) return
      lockReconnect = true
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt)
      that.timer = setTimeout(function () {
        that.init()
        lockReconnect = false
      }, 4000)

    },


    getListTimer() {
      const that = this,
          list = that.timerList

      console.log('getListTimer', list)
      that.scoreList.map((score, scoreIndex) => {
        list.map(row => {
          if (scoreIndex === row.index) {
            score.timer = row.timer
            score.timeStatus = row.timeStatus
          }
        })
      })

    },

    // 开始计时
    onTimeStart(status ) { 
      const that = this,
          index = that.currentIndex,
          list = that.scoreList,
          row = list[index]

      row.timeStatus = status


      let timeTotal = that.getTimeSecond(list[index].stime)

      timeTotal += 1
      const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
          endTime = timeTotal * 1000 + today,
          date = that.formatDate(endTime, 'h:m:s')

      that.scoreList[index].stime = that.sTime = that.timeString = date
      that.timeTotal = timeTotal
      that.onTimeConfirm()

      if (status === 'pause') {
        return
      }


      // timer fetch的定义
      var timer = row.timer = setInterval(function () {
        console.log('onTimerActive')

        timeTotal += 1

        const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
            endTime = timeTotal * 1000 + today,
            date = that.formatDate(endTime, 'h:m:s')

        that.scoreList[index].stime = that.sTime = that.timeString = date
        that.timeTotal = timeTotal

        that.onTimeConfirm()
      }, 1000)

      const timeRow = {
        index: index,
        timer: timer,
        timeStatus: status
      }
      that.timerList.push(timeRow)
    },

    onTimePause() {
      const that = this,
          index = that.currentIndex,
          list = that.scoreList,
          row = list[index]


      clearInterval(row.timer)

      this.onTimeStart('pause')


      // that.isContinue = true
      // clearInterval(row.timer)
    },

    onTimeRestart() {
      let that = this,
          index = that.currentIndex,
          list = that.scoreList

      //  找不到timer 问题
      clearInterval(list[index].timer)
      list[index].stime = '00:00:00'
      this.onTimeStart('start')
    },

    onTimeConfirm() {
      // todo 不要从服务端获取时间
      let that = this,
          index = that.currentIndex,
          list = that.scoreList

      that.sTime = list[index].stime
      // this.openChange()
    },

    getSubjectOptions() {
      let that = this;
      subjectOptions({saiqu: that.row.saiqu}).then(res => {
        that.subjectOptions = res.data
      });
    },
 

    getTimeSecond(time) {
      if (!time) {
        return '00:00:00'
      }
      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(sec)

      // console.log(hour, min, sec, Number(min * 60), Number(sec * 60))

      // console.log(time+ '-----' + s)
      return s
    },

    // 格式化为时间字符串
    // minute 添加的时间
    formatTimeToTime(time, minute ) {
      // let time = '03:58:00',
      //     minute = 3,
      let date = '',
          today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()

      // 如何得到 03:33:00

      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(minute * 60) + Number(sec)

      let endTime = s * 1000 + today

      date = this.formatDate(endTime, 'h:m:s')
      // console.log('formatTimeToTime', min,endTime, date)

      return date
    },

    formatDate(num, format) {
      const formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
      const returnArr = [];
      const date = new Date(num);
      returnArr.push(date.getFullYear()); // 取得4位数的年份
      returnArr.push(this.formatNumber(date.getMonth() + 1)); // 取得日期中的月份，其中0表示1月，11表示12月
      returnArr.push(this.formatNumber(date.getDate())); // 返回日期月份中的天数（1到31）
      returnArr.push(this.formatNumber(date.getHours())); // 返回日期中的小时数（0到23）
      returnArr.push(this.formatNumber(date.getMinutes())); // 返回日期中的分钟数（0到59）
      returnArr.push(this.formatNumber(date.getSeconds())); // 返回日期中的秒数（0到59）

      for (const i in returnArr) {
        // 判断对象是否含有某个非继承属性
        if ({}.hasOwnProperty.call(returnArr, i)) {
          format = format.replace(formateArr[i], returnArr[i]); // 替换
        }
      }
      return format;
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : `0${n}`;
    },
  }
}
</script>



// WEBPACK FOOTER //
// CommonScoreCheck.vue?d8163b10